// // src/pages/Reports/ReportTable.js
// import React, { useState } from "react"
// import { Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
// import classnames from "classnames"

// // Table components
// import NormalReportTable from "./tables/NormalReportTable"
// import BajajDebitTable from "./tables/BajajDebitTable"
// import BajajCreditTable from "./tables/BajajCreditTable"
// import BajajMappedTable from "./tables/BajajMappedTable"
// import OtherMappedTable from "./tables/OtherMappedTable"

// const ReportTable = ({ filters }) => {
//   const [activeTab, setActiveTab] = useState("normal")
//   const [bajajSubTab, setBajajSubTab] = useState("debit")
//   const [mappedSubTab, setMappedSubTab] = useState("bajaj")

//   const toggleMainTab = tab => {
//     if (activeTab !== tab) setActiveTab(tab)
//   }

//   const toggleBajajSubTab = sub => {
//     if (bajajSubTab !== sub) setBajajSubTab(sub)
//   }

//   const toggleMappedSubTab = sub => {
//     if (mappedSubTab !== sub) setMappedSubTab(sub)
//   }

//   return (
//     <Card className="shadow border-0 mb-0">
//       <div className="card-header border-0 py-3 px-4 d-flex align-items-center justify-content-between">
//         <h5 className="mb-0 fw-semibold">Report Details</h5>

//         {/* Export dropdown POORA HATA DIYA – ab har table ke andar button hai */}
//       </div>

//       <CardBody className="p-4">
//         {/* Main Tabs */}
//         <Nav tabs className="nav-tabs-custom mb-4">
//           <NavItem>
//             <NavLink
//               className={classnames({ active: activeTab === "normal" })}
//               onClick={() => toggleMainTab("normal")}
//             >
//               Normal
//             </NavLink>
//           </NavItem>
//           <NavItem>
//             <NavLink
//               className={classnames({ active: activeTab === "bajaj" })}
//               onClick={() => toggleMainTab("bajaj")}
//             >
//               Bajaj Report
//             </NavLink>
//           </NavItem>
//           <NavItem>
//             <NavLink
//               className={classnames({ active: activeTab === "mapped" })}
//               onClick={() => toggleMainTab("mapped")}
//             >
//               Mapped Report
//             </NavLink>
//           </NavItem>
//         </Nav>

//         {/* Tab Contents */}
//         <div className="tab-content">
//           {activeTab === "normal" && (
//             <NormalReportTable filters={filters} tabName="normal" />
//           )}

//           {activeTab === "bajaj" && (
//             <>
//               <Nav tabs className="nav-tabs-custom mb-3">
//                 <NavItem>
//                   <NavLink
//                     className={classnames({ active: bajajSubTab === "debit" })}
//                     onClick={() => toggleBajajSubTab("debit")}
//                   >
//                     Bajaj Debit
//                   </NavLink>
//                 </NavItem>
//                 <NavItem>
//                   <NavLink
//                     className={classnames({ active: bajajSubTab === "credit" })}
//                     onClick={() => toggleBajajSubTab("credit")}
//                   >
//                     Bajaj Credit
//                   </NavLink>
//                 </NavItem>
//               </Nav>

//               {bajajSubTab === "debit" && (
//                 <BajajDebitTable filters={filters} tabName="bajaj-debit" />
//               )}
//               {bajajSubTab === "credit" && (
//                 <BajajCreditTable filters={filters} tabName="bajaj-credit" />
//               )}
//             </>
//           )}

//           {activeTab === "mapped" && (
//             <>
//               <Nav tabs className="nav-tabs-custom mb-3">
//                 <NavItem>
//                   <NavLink
//                     className={classnames({ active: mappedSubTab === "bajaj" })}
//                     onClick={() => toggleMappedSubTab("bajaj")}
//                   >
//                     Bajaj Mapped
//                   </NavLink>
//                 </NavItem>
//                 <NavItem>
//                   <NavLink
//                     className={classnames({ active: mappedSubTab === "other" })}
//                     onClick={() => toggleMappedSubTab("other")}
//                   >
//                     Other Mapped
//                   </NavLink>
//                 </NavItem>
//               </Nav>

//               {mappedSubTab === "bajaj" && (
//                 <BajajMappedTable filters={filters} tabName="bajaj-mapped" />
//               )}
//               {mappedSubTab === "other" && (
//                 <OtherMappedTable filters={filters} tabName="other-mapped" />
//               )}
//             </>
//           )}
//         </div>
//       </CardBody>
//     </Card>
//   )
// }

// export default ReportTable

// src/pages/Reports/ReportTable.js
import React, { useState, useRef } from "react"
import { Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

// Table components
import NormalReportTable from "./tables/NormalReportTable"
import BajajDebitTable from "./tables/BajajDebitTable"
import BajajCreditTable from "./tables/BajajCreditTable"
import BajajMappedTable from "./tables/BajajMappedTable"
import OtherMappedTable from "./tables/OtherMappedTable"

const ReportTable = ({ filters }) => {
  const [activeTab, setActiveTab] = useState("normal")
  const [bajajSubTab, setBajajSubTab] = useState("debit")
  const [mappedSubTab, setMappedSubTab] = useState("bajaj")

  // Shared cache – sab tables ke liye common (tab switch hone par bhi nahi mitta)
  const sharedCache = useRef(new Map())

  const toggleMainTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const toggleBajajSubTab = sub => {
    if (bajajSubTab !== sub) setBajajSubTab(sub)
  }

  const toggleMappedSubTab = sub => {
    if (mappedSubTab !== sub) setMappedSubTab(sub)
  }

  // Har tab/sub-tab ke liye unique prefix banane ke liye
  const getTabKey = () => {
    if (activeTab === "normal") return "normal"
    if (activeTab === "bajaj") return `bajaj-${bajajSubTab}`
    if (activeTab === "mapped") return `mapped-${mappedSubTab}`
    return "unknown"
  }

  return (
    <Card className="shadow border-0 mb-0">
      <div className="card-header border-0 py-3 px-4 d-flex align-items-center justify-content-between">
        <h5 className="mb-0 fw-semibold">Report Details</h5>
      </div>

      <CardBody className="p-4">
        {/* Main Tabs */}
        <Nav tabs className="nav-tabs-custom mb-4">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "normal" })}
              onClick={() => toggleMainTab("normal")}
            >
              Normal
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "bajaj" })}
              onClick={() => toggleMainTab("bajaj")}
            >
              Bajaj Report
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "mapped" })}
              onClick={() => toggleMainTab("mapped")}
            >
              Mapped Report
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Contents */}
        <div className="tab-content">
          {activeTab === "normal" && (
            <NormalReportTable
              filters={filters}
              tabKey={getTabKey()}
              sharedCache={sharedCache}
            />
          )}

          {activeTab === "bajaj" && (
            <>
              <Nav tabs className="nav-tabs-custom mb-3">
                <NavItem>
                  <NavLink
                    className={classnames({ active: bajajSubTab === "debit" })}
                    onClick={() => toggleBajajSubTab("debit")}
                  >
                    Bajaj Debit
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: bajajSubTab === "credit" })}
                    onClick={() => toggleBajajSubTab("credit")}
                  >
                    Bajaj Credit
                  </NavLink>
                </NavItem>
              </Nav>

              {bajajSubTab === "debit" && (
                <BajajDebitTable
                  filters={filters}
                  tabKey={getTabKey()}
                  sharedCache={sharedCache}
                />
              )}
              {bajajSubTab === "credit" && (
                <BajajCreditTable
                  filters={filters}
                  tabKey={getTabKey()}
                  sharedCache={sharedCache}
                />
              )}
            </>
          )}

          {activeTab === "mapped" && (
            <>
              <Nav tabs className="nav-tabs-custom mb-3">
                <NavItem>
                  <NavLink
                    className={classnames({ active: mappedSubTab === "bajaj" })}
                    onClick={() => toggleMappedSubTab("bajaj")}
                  >
                    Bajaj Mapped
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: mappedSubTab === "other" })}
                    onClick={() => toggleMappedSubTab("other")}
                  >
                    Other Mapped
                  </NavLink>
                </NavItem>
              </Nav>

              {mappedSubTab === "bajaj" && (
                <BajajMappedTable
                  filters={filters}
                  tabKey={getTabKey()}
                  sharedCache={sharedCache}
                />
              )}
              {mappedSubTab === "other" && (
                <OtherMappedTable
                  filters={filters}
                  tabKey={getTabKey()}
                  sharedCache={sharedCache}
                />
              )}
            </>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default ReportTable
